import { Action } from '@ngrx/store';
import { AuctionLotDetail } from '@viewbid/ts-angular-client';

export enum SelectedLotUIActions {
    SelectLotAction = '[UI] Select Lot',
}

interface SelectLotActionProps {
    lotId: string;
}
export class SelectLotAction implements Action {
    readonly type: SelectedLotUIActions = SelectedLotUIActions.SelectLotAction;

    public props: SelectLotActionProps;

    constructor(props: SelectLotActionProps) {
        this.props = props;
    }
}

export enum SelectedLotServiceActions {
    LotFetchedSuccessfulAction = '[Get Lot Service] Lot retrieved',
    LotFetchedFailedAction = '[Get Lot Service] Unable to retrieve lot',
}

export interface LotFetchedSuccessfulActionProps {
    result: AuctionLotDetail;
}

export class LotFetchedSuccessfulAction implements Action {
    readonly type: SelectedLotServiceActions =
        SelectedLotServiceActions.LotFetchedSuccessfulAction;

    public props: LotFetchedSuccessfulActionProps;

    constructor(props: LotFetchedSuccessfulActionProps) {
        this.props = props;
    }
}

export interface LotFetchedFailedActionProps {
    errorCode?: string;
}

export class LotFetchedFailedAction implements Action {
    readonly type: SelectedLotServiceActions =
        SelectedLotServiceActions.LotFetchedFailedAction;
    public props?: LotFetchedFailedActionProps;

    // accept optional props with errorCode
    constructor(props?: LotFetchedFailedActionProps) {
        this.props = props;
    }
}
